import {
  BBB_PROFILE_URL,
  BBB_SEAL_IMAGE_URL,
  LEGITSCRIPT_BADGE_SRC,
  LEGITSCRIPT_PROFILE_URL,
  SSL_SECURE_BADGE_SRC,
} from 'constants/footer'
import React from 'react'
import styles from '../index.module.scss'

const FooterTrustBadges: React.FC = () => {
  return (
    <div className={styles.footer_badges} data-testid="footer-trust-badges">
      <div className={styles.footer_badge_slot} data-testid="bbb-seal">
        <a
          href={BBB_PROFILE_URL}
          id="bbblink"
          className={`rbvtbus ${styles.bbb_seal_link}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <img
            src={BBB_SEAL_IMAGE_URL}
            alt="Thriveworks Administrative Services, LLC BBB Business Review"
            className={styles.bbb_seal_image}
          />
        </a>
      </div>

      <a
        href={LEGITSCRIPT_PROFILE_URL}
        className={styles.footer_badge_link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="legitscript-badge"
      >
        <img
          src={LEGITSCRIPT_BADGE_SRC}
          alt="LegitScript certified"
          width={59}
          height={64}
          className={styles.footer_badge_image}
        />
      </a>

      <img
        src={SSL_SECURE_BADGE_SRC}
        alt="SSL Secure"
        width={49}
        height={64}
        className={styles.footer_badge_image}
        data-testid="ssl-secure-badge"
      />
    </div>
  )
}

export default FooterTrustBadges
